import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledCardContentProps {
  variant: 'opportunity' | 'risk';
}

const shouldForwardProp = (prop: PropertyKey) => !['variant'].includes(prop as string);

export const StyledCardContent = styled(Box, {
  shouldForwardProp,
})<StyledCardContentProps>(({ theme, variant }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3),
  gap: theme.spacing(2),
  '&:hover': {
    backgroundColor:
      variant === 'opportunity' ? theme.palette['mint-green'][50] : theme.palette.orange[50],
  },
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

export const StyledCardTitle = styled(Box)(({ theme }) => ({
  flex: 0.95,
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    width: '100%',
    flex: 'none',
  },
}));

export const StyledCardValue = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  textAlign: 'right',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'left',
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
    border: 'none',
  },
}));
